<div class="header">
  {{ 'm/task-process/send_and/transfer_to' | translate }}
</div>
<ion-content>
  <ion-list lines="none">
    <ion-radio-group [(ngModel)]="selectedTeam">
      <ion-item *ngFor="let team of teams">
        <ion-label>{{ team.label }}</ion-label>
        <ion-radio slot="start" color="primary" [value]="team"></ion-radio>
      </ion-item>
    </ion-radio-group>
  </ion-list>
</ion-content>
<div class="footer">
  <ion-button (click)="ok(selectedTeam)" [disabled]="!selectedTeam">
    {{ 'm/ok' | translate }}
  </ion-button>
  <ion-button (click)="cancel()" fill="outline">
    {{ 'm/cancel' | translate }}
  </ion-button>
</div>
